import React, { useContext } from "react";
import { ResultsEventContext } from "@state/context/results";

export default function Odd() {
	const event = useContext(ResultsEventContext);

	if (event.odd !== "-" && parseFloat(event.odd) % 1 === 0) {
		return (
			<td className="table--results__body__data table--results__body__data--odd">
				<span className="u-type--wgt--medium">
					{parseFloat(event.odd).toFixed(1)}
				</span>
			</td>
		);
	}

	return (
		<td className="table--results__body__data table--results__body__data--odd">
			<span className="u-type--wgt--medium">{event.odd}</span>
		</td>
	);
}
